import type { EventArtist as GQLItem } from '../../generated/graphql';
import * as Artist from './Artist';
import { take } from '../../util';

export type EventArtist = {
  id: number;
  artist?: Artist.Artist;
  legacyEventArtistId?: number;
  legacySettlementSheetId?: number;
  offerSheetId?: number;
  headliner?: boolean;
};

export const fromGql = (item: GQLItem): EventArtist => ({
  ...take<EventArtist>(item, 'id', 'legacyEventArtistId', 'legacySettlementSheetId', 'offerSheetId', 'headliner'),
  artist: item.artist ? Artist.fromGql(item.artist) : undefined,
});

export const fromGqlCollection = (items: GQLItem[]): EventArtist[] => items.map(item => fromGql(item));
